import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import moment from "moment"
import React from "react"
import { View } from "react-native"
import StudyItemComponent from "./StudyItemComponent"

const DaySectionComponent = (props) => {
    const {
        dayData,
        schoolSubjects,
        startDate,
        onPress = () => {},
        highlightedChapterId,
        showChapterProgress = false
    } = props;

    const dayNumbers = {
        "lundi": 0,
        "mardi": 1,
        "mercredi": 2,
        "jeudi": 3,
        "vendredi": 4,
        "samedi": 5,
        "dimanche": 6,
    }

    const start = moment(startDate)
    const startDateGap = dayNumbers?.[start?.format("dddd")]

    const getDayName = (dayNumber) => {
        const dayNames = [
            "Lundi",
            "Mardi",
            "Mercredi",
            "Jeudi",
            "Vendredi",
            "Samedi",
            "Dimanche",
        ]

        const dayOfWeek = ((dayNumber + startDateGap - 1) % 7)
        return dayNames[dayOfWeek]
    }

    const getExactDate = (dayNumber) => {
        if (!startDate) return null

        const start = moment(startDate)
        const targetDate = start.clone().add(dayNumber - 1, "days")
        return targetDate
    }

    const dayName = getDayName(dayData.day)
    const weekNumber = Math.ceil(dayData.day / 7)
    const exactDate = getExactDate(dayData.day)

    return (
        <View style={{ marginBottom: 20 }}>
            <TextM
                color={theme.colors.primary}
                fontSize={16}
                fontWeight="Bold"
                style={{ marginBottom: 10 }}
            >
                {dayName}
                {exactDate  ? ` • ${exactDate.format("DD/MM/YYYY")}` : `- Jour ${dayData.day} (Semaine ${weekNumber})`}
            </TextM>
            {dayData.items.map((item, index) => (
                <StudyItemComponent
                    key={index}
                    item={item}
                    schoolSubjects={schoolSubjects}
                    onPress={() => onPress(item)}
                    highlighted={item.chapter?.id === highlightedChapterId}
                    showChapterProgress={showChapterProgress}
                />
            ))}
        </View>
    )
}

export default DaySectionComponent
